import makeService from './api';

export default makeService('setup_definitions');
